
import { Row, Col } from 'react-bootstrap';
import { formatPrice } from './functions';

const CartItemRow = ({ item, index, title }) => (
  <Row key={`${title}-${index}`}>
    <Col xs={5}><span>{item.Item}</span></Col>
    <Col xs={4}><span>{formatPrice(item.Price)}</span></Col>
  </Row>
);

export default CartItemRow;
